"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ratio = _interopRequireDefault(require("../../../shapes/ratio.shape"));

var _default = _propTypes.default.shape({
  id: _propTypes.default.string.isRequired,
  thumbnailUrl: _propTypes.default.string.isRequired,
  ratio: _ratio.default.isRequired,
  title: _propTypes.default.string.isRequired,
  createdDate: _propTypes.default.number.isRequired
});

exports.default = _default;